import { createGlobalStyle } from 'styled-components';
import { colorTheme, extraColor } from '@styles/muiTheme';

export const StyleOverride = createGlobalStyle`
  .leads {
    svg.actions-icon {
      stroke: ${colorTheme.palette.secondary.dark}
    }
    
    div.MuiDataGrid-row.Mui-selected {
      svg.actions-icon {
        stroke: ${colorTheme.palette.info.dark}
      }
    }
    
    .Mui-disabled svg.actions-icon {
      stroke: ${extraColor.palette.grey[400]} !important
    }
  }

  .lead-communications {
    padding: 15px 25px 0;

    div.MuiDataGrid-main,
    div.MuiDataGrid-columnHeaders {
      background: ${colorTheme.palette.common.white};
    }
  }
`;
